<template>
  <li
    class="calendar-day"
    :class="{
      'calendar-day--not-current': !day.isCurrentMonth,
      'calendar-day--today': isToday,
      'calendar-day--have-event': haveEvent
    }"
  >
  <span v-if="haveEvent" @click.prevent="selectDeadlineToCalendarlist()">{{ label }}<i>{{ countEvents }}</i></span>
  <span v-else>{{ label }}</span>
  </li>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "CalendarMonthDayItem",

  props: {
    day: {
      type: Object,
      required: true
    },

    isCurrentMonth: {
      type: Boolean,
      default: false
    },

    isToday: {
      type: Boolean,
      default: false
    },

    deadlines: {
      type: Array,
      default: false
    }
  },

  data() {
    return {
      //
    };
  },

  computed: {
    currentDate() {
      return dayjs(this.day.date).format("YYYY-MM-DD");
    },

    countEvents() {
      let that = this;
      let count = 0;
      this.deadlines.map((deadline, index) => {
        if(that.currentDate === deadline) {
          count++;
        }
      });
      return count;
    },

    haveEvent() {
      let currentDate = dayjs(this.day.date).format("YYYY-MM-DD");
      return this.deadlines.includes(currentDate);
    },

    label() {
      return dayjs(this.day.date).format("D");
    }
  },

  methods: {
    selectDeadlineToCalendarlist() {
      this.$emit("deadlineSelected", this.day);
    }
  }
};
</script>

<style scoped>
  .calendar-day.calendar-day--have-event span {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// ./src/components/CalendarMonthDayItem.vue